import {ApiUserProfile} from './api/auth';
import {INTERNAL_ORGANIZATION_ID} from './constants';

/**TODO(eva): this util is copied from Lens and is a good candidate to work on
a shared directory because it's easy to test across multiple products */
export function isUpstreamEmail(email: string | null) {
  return /^\S*@upstream.tech$/.test(email || '');
}

export function isUpstreamInternalOrgUser(profile: ApiUserProfile | null): boolean {
  // Auth provider may return null for these if we're not logged in. Return false here, conservatively.
  if (!profile) {
    return false;
  }
  return isUpstreamEmail(profile.email) && profile.organizationKey === INTERNAL_ORGANIZATION_ID;
}
